import { useCallback, useEffect, useLayoutEffect } from 'react';
import { useFormInputAccountPassword } from 'src/components/FormInput';
import { ACCOUNT_PASSWORD_CONFIRM_VALIDATE_ERROR } from 'src/constants/validate';
import Button from 'src/components/Button';
import { userPasswordChangeMe } from 'src/services/api';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useAppDispatch } from 'src/AppContext';
import { useModal } from 'src/ModalContext';

export default function UserChange(): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useCustomHistory();
  const { showModal, errorModal } = useModal();
  const passwordInput = useFormInputAccountPassword({
    label: t('password/change/password_button'),
  });
  const passwordConfirmInput = useFormInputAccountPassword({
    label: t('password/change/password_confirm_button'),
    name: 'passwordConfirm',
    validate: {
      required: (value: string) => !!value,
      match: (value: string) => passwordInput.value === value,
    },
    errors: ACCOUNT_PASSWORD_CONFIRM_VALIDATE_ERROR,
    inputAttr: {
      placeholder: 'account/form/password_confirm_placeholder',
    },
  });

  useEffect(() => {
    if (passwordInput.value !== '' && passwordConfirmInput.value !== '') {
      passwordConfirmInput.triggerValidate();
      passwordInput.triggerValidate();
    }
  }, [passwordInput.value, passwordConfirmInput.value]);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      userPasswordChangeMe({
        newPassword: e.target.password.value,
      })
        .then(() => {
          showModal({
            message: t('password/change/me/complete_alert'),
            success: () => {
              history.replace('/user');
            },
          });
        })
        .catch(errorModal);
    },
    [history],
  );

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.goBack();
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  return (
    <>
      <form onSubmit={onSubmit}>
        <div className="container pb-10 mt-6">
          <h1 className="N_20_R">{t('password/change/title')}</h1>
          <div className="mt-7">{passwordInput.CustomFormInput}</div>
          <div className="mt-5">{passwordConfirmInput.CustomFormInput}</div>
          <div className="mt-6">
            <Button
              title={t('password/change/change_button')}
              type="submit"
              disabled={!(passwordInput.isValid && passwordConfirmInput.isValid)}
            ></Button>
          </div>
        </div>
      </form>
    </>
  );
}
